import { call, put, select, takeLatest } from 'redux-saga/effects';
import { replace } from 'ramda';
import customerService from '../services/customer';
import { selectConfig } from '../features/config/configSlice';
import { normalizeSaveMarketingConsentsRequestBody } from '../utils/registerUtils';

export function* register({ values }) {
  let errors = null;

  try {
    const config = yield select(selectConfig);

    const {
      email,
      firstNames,
      password,
      surname,
      title,
      products,
      promotions,
      travelUpdates,
      isOver16,
      phoneNumber,
      smsMarketing,
    } = values;

    const result = yield call(customerService.register, {
      email,
      firstNames,
      password,
      surname,
      title,
      products,
      promotions,
      travelUpdates,
      isOver16,
      phoneNumber,
      smsMarketing,
      config,
    });

    if (result.errors || !result.accessToken) {
      errors = result.errors;
      throw new Error('Failure to register user');
    }

    const { accessToken, id, refreshToken } = result;

    const formattedToken = replace('/customers/auth/', '')(accessToken);

    yield put({
      type: 'register/registerSuccess',
      payload: { values, userId: id, accessToken: formattedToken },
    });
    yield put({ type: 'user/setUser', payload: { email, firstNames, id, surname, title } });
    yield put({
      type: 'user/setTokens',
      payload: {
        accessToken: formattedToken,
        refreshToken,
      },
    });
  } catch {
    yield put({ type: 'register/registerFailure', payload: errors[0].message });
  }
}

export function* saveMarketingConsents({ payload: { values, userId, accessToken } }) {
  try {
    const config = yield select(selectConfig);
    const requestBody = normalizeSaveMarketingConsentsRequestBody({ formValues: values });
    yield call(customerService.saveMarketingConsents, { config, userId, requestBody, accessToken });
  } catch (error) {
    yield put({ type: 'register/saveMarketingConsentsFailure', error });
  }
}

export function* openRegisterModal() {
  yield put({ type: 'register/resetForm' });
}

export function* registerSaga() {
  yield takeLatest('register/createUser', register);
  yield takeLatest('globalModals/openRegisterModal', openRegisterModal);
  yield takeLatest('register/registerSuccess', saveMarketingConsents);
}

export default registerSaga;
